import { z } from "zod";

// 50142 wrong password
// 50157 same as current
// 50257 5 last passwords
export const verificationErrorResponse = z.object({
  code: z.literal("50142").or(z.literal("50157")).or(z.literal("50257")),
});
